export const shareMenuItemsConfig: {
  text: string;
  value: string;
}[] = [
  {
    text: 'Copy Link',
    value: 'copy_link',
  },
  {
    text: 'Facebook Share',
    value: 'facebook_share_link',
  },
  {
    text: 'Whatsapp Share',
    value: 'whatsapp_share_link',
  },
];
export const moreMenuItemsConfig: {
  text: string;
  value: string;
}[] = [
  {
    text: 'Report Error',
    value: 'popup',
  },
  {
    text: 'Submit a Review',
    value: 'submit_a_review',
  },
  {
    text: 'Browsing History',
    value: 'browsing_history',
  },
];
